import '../css/topBarStyling.css';
import { useAuth } from '../utils/auth';
import { useNavigate } from 'react-router-dom';

const Top = () => {

    const auth = useAuth();
    const navigate = useNavigate();

        
    const handleLogout = () => {
        auth.logout();
        navigate('/');
    }

    return (
        <div className="mainTopBar">
            <div className="logoContainer">
                <img src="/images/BrinkruitersLogo.jpg" alt="" />
            </div>
            <div className="mainTopBarContainer">
                <div className="titleContainer">
                    <h1>RV de Brinkruiters</h1>
                    <h2>Leden App</h2>
                </div>


                {/* section below conditional, only while logged in */}
                {
                    auth.user &&
                    <div className="topBarUserContainer">
                        <div className='topBarUserProfile'>
                            <div className='topBarUsername'>
                                    <h2>{auth.user.gebruikersnaam}</h2>
                            </div>
                            
                        </div>
                        <div className='topBarLogout'>
                            <button className='button' onClick={handleLogout}>Uitloggen</button>
                            
                        </div>
                    </div>
                }
            </div>

        
        </div>
    );
}

export default Top;